import React, { useState } from "react";
import { Collapse, Table, Button, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import BloodStock from "./BloodStock"
import BloodDonation from "./BloodDonation"
const { Panel } = Collapse;
const { Option } = Select;

const BloodBankDashboardContent = () => {
  const [incomingRequestData, setIncomingRequestData] = useState([
    {
      patientname: "Mohit",
      patientaddress: "Testing data",
      patientAge:24
    },
    {
      patientname: "Mohit",
      patientaddress: "Testing data",
      patientAge:24
    },
  ]);
  const [pendingApprovalsData, setpendingApprovalsData] = useState([
    {
      patientname: "Mohit",
      patientaddress: "Testing data",
      patientAge:24
    },
    {
      patientname: "Mohit",
      patientaddress: "Testing data",
      patientAge:24
    },
  ]);
  const incomingBloodBankColumn = [
    {
      title: "Patient Name",
      dataIndex: "patientname",
      key: "patientname",
    },
    {
      title: "Pateint Address",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Pateint Age",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Pateint Sex",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Request Type",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Payment Status",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button type="primary">Accept</Button>
          <Button type="primary" danger>
            Reject
          </Button>
        </div>
      ),
    },
  ];
  const pendingBloodBankColumn = [
    {
      title: "Patient Name",
      dataIndex: "patientname",
      key: "patientname",
    },
    {
      title: "Pateint Address",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Pateint Age",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Pateint Sex",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Request Type",
      dataIndex: "patientaddress",
      key: "patientaddress",
    },
    {
      title: "Payment Status",
      dataIndex: "patientaddress",
      key: "patientaddress",
    }
  ];
  return (
    <div className="BloodBankDashboardContent">
      <Table
         title={() => <h2 style={{ margin: 0 }}>Incoming Request</h2>} 
        columns={incomingBloodBankColumn}
        dataSource={incomingRequestData}
        pagination={false} // Disable pagination
      />
      <Table
         title={() => <h2 style={{ margin: 0 }}>Pending Request</h2>} 
        columns={pendingBloodBankColumn}
        dataSource={pendingApprovalsData}
        pagination={false} // Disable pagination
      />
    </div>
  );
};
const AcceptedRequest = () => {
  const [acceptedRequestData, setAcceptedRequestData] = useState([
    {
      patientname: "Mohit",
      patientaddress: "Testing data",
    },
    {
      patientname: "Mohit",
      patientaddress: "Testing data",
    }
  ]);
  const accpetedRequestColumn=[
    {
      title: "Patient Name",
      dataIndex: "patientname",
      key: "patientname",
    },
    {
      title: "Pateint Address",
      dataIndex: "patientaddress",
      key: "patientaddress",
    }
  ]
  return (
    <div className="accepted-request-container">
      <Table
         title={() => <h2 style={{ margin: 0 }}>Incoming Request</h2>} 
        columns={accpetedRequestColumn}
        dataSource={acceptedRequestData}
        pagination={false} // Disable pagination
      />
    </div>
  );
};



const BloodBankDashboard = () => {
  return (
    <div className="blood-bank-dashboard">
      <div style={{ margin: "20px" }}>
        <Collapse accordion>
          <Panel header="Blood Bank Dashboard" key="1">
            <BloodBankDashboardContent />
          </Panel>
          <Panel header="Blood Stock" key="2">
            <BloodStock />
          </Panel>
          <Panel header="Accepted Request" key="3">
            <AcceptedRequest />
          </Panel>
          <Panel header="Blood Donation" key="4">
            <BloodDonation />
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default BloodBankDashboard;
